import { render } from "./StoryDetails.vue?vue&type=template&id=06ff711e"
import script from "./StoryDetails.vue?vue&type=script&lang=js"
export * from "./StoryDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__